<template>
  <div data-vv-as="templateCollection">
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item">Templates Collections</li>
              <li class="breadcrumb-item active" aria-current="page">1</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-6">
                  <div class="d-flex align-items-center h-full" style="height: 100%;">
                    <div class="font-bold">
                      Collection 1
                    </div>
                  </div>
                </div>
                <div class="form-group col-6">
                  <button
                    class="float-right ml-3 text-white btn btn-primary d-none d-md-block"
                    @click="setFormAddTemplatesVisible(true)"
                  >
                    <i class="fas fa-plus"></i> Add new templates
                  </button>
                </div>
              </div>
              <div class="table-responsive">
                <div class="text-center">
                  <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                </div>
                <table class="table">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Access Code</th>
                    <th>Copy count</th>
                    <th>Slide count</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="(item, index) in templates"
                    :key="index"
                  >
                    <td class="pointer" @click.stop="handleCellClick(item.id, 'ID')">{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.accessCode }}</td>
                    <td>{{ item.copyCount }}</td>
                    <td>{{ item.slideCount }}</td>
                    <td>
                      <a href="#" @click.stop.prevent="handleDeleteTemplate(item)">Remove</a>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <div class="overflow-auto">
                  <b-pagination v-model="page" :total-rows="count" :per-page="perPage"></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FormAddTemplates
      v-if="isFormAddTemplatesVisible"
      :collectionId="collectionId"
      @close="setFormAddTemplatesVisible(false)"
      @refresh="fetchCollectionDetails(collectionId)"
    />

    <FormDeleteTemplate
      v-if="isFormDeleteTemplateVisible"
      :collectionId="collectionId"
      :template="selectedTemplate"
      @close="setFormDeleteTemplateVisible(false)"
      @refresh="fetchCollectionDetails(collectionId)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Config from "@/config"
import FormAddTemplates from '@/views/apps/template-collections/FormAddTemplates.vue'
import FormDeleteTemplate from '@/views/apps/template-collections/FormDeleteTemplate.vue'

export default {
  name: "TemplateCollectionDetail",
  components: {
    FormAddTemplates,
    FormDeleteTemplate,
  },
  data() {
    return {
      collectionId: parseInt(this.$route.params.id, 10),
      selectedTemplate: null,
      page: 1,
      count: 0,
      perPage: 30,
      isFormAddTemplatesVisible: false,
      isFormDeleteTemplateVisible: false,
    }
  },
  computed: {
    ...mapState('templateCollection', {
      templates: state => state.collectionDetails && state.collectionDetails.templates,
      isLoading: state => state.isLoading,
    }),
  },
  watch: {
    collectionId: {
      handler(newVal) {
        if (!newVal) return

        this.fetchCollectionDetails(parseInt(newVal, 10))
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('templateCollection', ['fetchCollectionDetails', 'addTemplates', 'deleteTemplate']),

    setFormAddTemplatesVisible(value) {
      this.isFormAddTemplatesVisible = value
    },

    setFormDeleteTemplateVisible(value) {
      this.isFormDeleteTemplateVisible = value
    },

    handleDeleteTemplate(item) {
      this.selectedTemplate = item
      this.setFormDeleteTemplateVisible(true)
    },
    handleCellClick(data, cellName) {
      // Check if any text is selected; if so, do not trigger the click action.
      if (window.getSelection().toString().length > 0) {
          return
      }

      switch (cellName) {
        case 'ID':
          this.goToPublicTemplate(data)
          break
        default:
          break
      }
    },
    goToPublicTemplate(id) {
      window.open(`${Config.publicTemplateUrl}/p/${id}/`, "_blank")
    },
  }
}
</script>
